// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2QcnL","label":"SetPasswdForm_label__19BwO"};